(()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('[data-voice-clean]').forEach(video=>{
  let visible=false,manualPause=false;
  const label=()=>{video.setAttribute('aria-label',`XNote Voice demonstration. Click or press Space to ${video.paused?'play':'pause'}.`);video.setAttribute('aria-pressed',String(video.paused));};
  const sync=()=>{if(visible&&!document.hidden&&!reduced.matches&&!manualPause)video.play().catch(label);else video.pause();};
  const toggle=()=>{if(video.paused){manualPause=false;video.play().catch(label);}else{manualPause=true;video.pause();}};
  video.addEventListener('click',toggle);
  video.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();toggle();}});
  video.addEventListener('play',label);video.addEventListener('pause',label);
  new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.2}).observe(video);
  document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);label();
 });
})();
